(ns
  frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.controller
  (:require
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.page.lp-portal.report.util :as util]))

(defn- overview-figures
  [basic-equity]
  [["Entry date" (util/->date-dd-MM-yyyy (:entry-date basic-equity))]
   ["EV at entry" (:ev-at-entry basic-equity)]
   ["Entry multiple" (:entry-multiple basic-equity)]
   ["Total amount invested by Fund" (:total-amount-invested-by-fund basic-equity)]
   ["Funds ownership" (util/->percent-1-decimal (:funds-ownership basic-equity))]
   ["Industry" (:industry basic-equity)]
   ["Number of employees" (:number-of-employees basic-equity)]
   ["Case team" (:case-team basic-equity)]])

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name       (get-in report-data [:holding-name])
   :reference-date     (get-in report-data [:reference-date])
   :report-id          (:report-id props)
   :case-overview-text (report-ctl/rich-content
                        props
                        :case-overview-text)
   :overview-figures   (report-ctl/with-footnote
                        props
                        :overview-figures-footnotes
                        (overview-figures (get-in report-data [:basic-equity])))
   :financials         (->>
                         (get-in report-data [:financials])
                         (report-ctl/with-footnote props :financials-footnotes)
                         (report-ctl/with-editable-charts
                          props
                          :financials
                          financials-controller/company-financials
                          financials-controller/config->editable-data
                          financials-controller/editable-data->raw-data))})
